<template>
  <div>
    <v-row no-gutters v-if="is_required == false">
      <v-col 
            cols="auto"
            class="ml-auto">
        <v-btn text small @click="skip">Skip »</v-btn>
      </v-col>
    </v-row>
    <!-- <v-row no-gutters justify="center" align="center">

      <v-col 
        cols="auto"
        class="ml-auto">

        <v-btn 
          class="ml-2 mb-2"
          rounded dark outlined 
          :style="{color: bot_setting.main_color}"

          v-for="(item, index) in selection_options" v-bind:key="index"

           @click.once="submit(index)"
        >
          <span class="v-label theme--light">{{item.title}}</span>
        </v-btn>

      </v-col>
      
    </v-row> -->

    <div class="selectBox">
      <div class="itemlist">
        <div class="selectItem" v-for="(item, index) in selection_options" v-bind:key="index" @click.once="submit(index)"><label><button>{{item.title}}</button></label></div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils.js'

export default {

  name: "SingleSelectionInput",

  props: ['placeholder', 'error_message', 'bot_setting', 'is_required', 'selection_options', 'label_name', 'question_id', 'answer_data', 'custom_validation'],

  created(){
    //console.log(this.selection_options)
    this.error_message_2 = this.error_message
  },

  data: () =>({
    btnDisabled: false,
    error_message_2: ''
  }),


  methods: {
    skip(){
      this.$emit('skip_input_submitted')
    },
    submit(data){
      if (this.customValidation(this.selection_options[data].value) == false) {
        this.btnDisabled = false
      }else{
        this.btnDisabled = true
        var emitValue = {user_chat_message: this.selection_options[data].title, user_chat_value:this.selection_options[data].value}
        this.$emit('single_selection_input_submitted', emitValue)
      }
    },

    customValidation(_input_value){
      if (this.custom_validation.length > 0){
        this.error_message_2 = ''
        var temp_answer_data = JSON.parse(JSON.stringify(this.answer_data))
        temp_answer_data.push({ 'key': this.label_name, 'value': _input_value, 'question_id': this.question_id })

        for(var j=0; j < this.custom_validation.length; j++){
          if (this.custom_validation[j].rule != ''){
            var validation_result = utils.runCustomValidation(this.custom_validation[j].rule, temp_answer_data)
            if (validation_result == false){
              this.error_message_2 = this.custom_validation[j].error_message
              return false
            }
          }
        }
      }
      return true
    }
  }
}
</script>